import React, { Component } from 'react';
import { connect } from 'react-redux';
import { appDone, appWait, loginRequest } from '../../store/actions';

import Login from '../../components/Login';

class Clogin extends Component {
    constructor(props) {
        super(props);
        this.handleLogin = this.handleLogin.bind(this);
    }

    componentWillMount(){
        if (this.props.loginState===0 || this.props.loginState===3)
            if (localStorage.getItem('loginData')){
                if (this.props.loginRequest({user:null,pswd:null}))
                    return null;
        }

    }
    
    handleLogin(data) {
        this.props.appWait();
        this.props.loginRequest(data);
    }

    render() {        
        return ( ( this.props.loginState===0 || this.props.loginState===3 ) &&
            <Login
                user={this.props.config.login.test_user}
                pswd={this.props.config.login.test_pswd}
                handleLogin={this.handleLogin}
                loginState={this.props.loginState}
                version={this.props.version} 

                texts={{
                    txt_user: this.props.txt_user,
                    txt_pswd: this.props.txt_pswd,
                    txt_start: this.props.txt_start,
                    txt_user_pass_invalid: this.props.txt_user_pass_invalid
                }}/>
        );
    }
}

const mapStateToProps = state => {
    const getText = (id) => {
        let text = '';
        try {
            text = state.app.texts[id][state.app.language];
        } catch (err) {
            text = '';
        }
        return text;
    }

    return {
        config: state.app.config,
        loginState: state.login.loginState,
        route: state.app.route,
        version: state.app.version,
        
        txt_user: getText("0002"),
        txt_pswd: getText("0003"),
        txt_start: getText("0004"),
        txt_user_pass_invalid: getText("0005")
    }
}

const mapDispatchToProps = dispatch => {
    return {
        appWait: () => dispatch(appWait()),
        appDone: () => dispatch(appDone()),

        loginRequest: (data) => dispatch(loginRequest(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Clogin);



// WEBPACK FOOTER //
// ./src/containers/Clogin/index.js